import { Form, message } from 'antd'
import { useAttemptListener } from 'dev-masters-react-kit'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import {
  attemptEditPlaylist,
  attemptGetPlaylist,
  EditPlaylistDTO,
  Playlist,
} from '../../../utils/redux/playlistsSlice'
import { listenerMiddleware, store, useAppDispatch } from '../../../utils/redux/store'
import PlaylistForm from '../../../components/PlaylistForm/PlaylistForm'
interface Props {}
interface Params extends Record<string, string> {
  id: string
}

export default function EditPlaylist({}: Props) {
  const { id } = useParams<Params>()

  const dispatch = useAppDispatch()
  const [userOrder, setUserOrder] = useState<string|undefined>()
  const [playlist, setPlaylist] = useState<Playlist>()

  useEffect(() => {
    async function getPlaylist() {
      const playlist = await dispatch(
        attemptGetPlaylist(id || 'undefined'),
      ).unwrap()
      setUserOrder(playlist.userOrder)
      setPlaylist(playlist)
    }

    getPlaylist()
  }, [])

  const isUpdating = useAttemptListener({
    listenerMiddleware: listenerMiddleware,

    attempt: attemptEditPlaylist,
    onFulfilled: () => message.success('Playlist has been successfully updated!'),
  })

  const isLoading = useAttemptListener({
    listenerMiddleware: listenerMiddleware,

    attempt: attemptGetPlaylist,
  })

  function onFinish(values: EditPlaylistDTO) {
    dispatch(attemptEditPlaylist({ ...values, _id: id || 'undefined' }))
  }

  return (
    <div className="content">
      <PlaylistForm
        onFinish={onFinish}
        userOrder={userOrder}
        isLoading={isLoading || isUpdating}
        playlist={playlist}
      />
    </div>
  )
}
